import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const CardWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

export const CardHeader = styled(Box)(({ theme }) => ({
  paddingBottom: 16,
  borderBottom: `1px solid ${theme.colors.gray[200]}`,
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 16,
}));

export const CardContent = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  flex: 1,
});
